import {
  RIVERSYSTEMLIST,
} from 'actions/riverSystem';
import {reducerPackage} from "../../utils";

export const riverSystem = reducerPackage(RIVERSYSTEMLIST);
